// extracted by mini-css-extract-plugin
module.exports = {"Map":"styles_Map__27oFe"};